import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import DetentionTile from '../parts/DetentionTile';

const styles = theme => ({
  statusHeading: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'capitalize',
    margin: '20px 0',
    color: '#394f5a',
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
    defaultDateRange: state.defaultDateRange,
  };
};

class DetentionsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detentions: [],
      detentionsLoading: false,
      detentionsLoaded: false,
      detentionsPerStatus: {},
      detentionsMeta: [],
    };

    this.axiosCancel = null;

    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      detentionsLoading: true,
    });

    axios
      .get(
        `${window.apiUrl}/detentions/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            detentions: response.data.data,
            detentionsMeta: response.data.meta,
          });
          this.processDetentions();
        }

        this.setState({
          detentionsLoading: false,
          detentionsLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  processDetentions() {
    const {
      detentions,
    } = this.state;

    const now = moment();
    const detentionsPerStatus = {
      today: [],
      future: [],
      past: [],
    };

    for (let i = 0; i < detentions.length; i++) {
      const detention = detentions[i];
      let detentionStatus = 'past';

      if (detention.date) {
        const detentionDate = moment(detention.date);
        if (detentionDate.isSame(now, 'day')) {
          detentionStatus = 'today';
        } else if (detentionDate.isAfter(now)) {
          detentionStatus = 'future';
        }
      }

      detentionsPerStatus[detentionStatus].push(detention);
    }

    // Display newer detentions first
    detentionsPerStatus.past = detentionsPerStatus.past.reverse();

    this.setState({ detentionsPerStatus });
  }

  render() {
    const {
      detentionsPerStatus,
      detentionsMeta,
      detentionsLoading,
      detentionsLoaded,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="detentions-page">
        {detentionsLoading && !detentionsLoaded && (
          <CircularProgress />
        )}
        {!detentionsLoading && detentionsLoaded && Object.keys(detentionsPerStatus).map(status => (
          <div
            className={classes.singleStatusSection}
            key={status}
          >
            <Typography className={classes.statusHeading}>
              {status}
            </Typography>
            {detentionsPerStatus[status].length === 0 && (
              <p>{t('No {detention_label} for this status.')
                .replace('{detention_label}', detentionsMeta.detention_alias_plural)}
              </p>
            )}
            {detentionsPerStatus[status].length > 0 && (
              <Grid
                container
                spacing={4}
              >
                {detentionsPerStatus[status].map(detention => (
                  <Grid
                    item
                    key={detention.id}
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                  >
                    <DetentionTile
                      detention={detention}
                      dateFormat={dateFormat}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(DetentionsPage))
);
